import { Dispatch, SetStateAction } from 'react';
import { LocalPersistence } from '@factories/Mutations/index';

const paginationSize = async (name: string, size: any) => {
  const session = new LocalPersistence(name, size);
  const dt = await session.getLocalPersistence();
  if (dt) {
    return await session.updateLocalPersistence({ ...dt, ...size });
  }
  return await session.setLocalPersistence();
};

const getPaginationSession = async (
  setState: Dispatch<SetStateAction<number>>,
  category: string
) => {
  try {
    const session = new LocalPersistence('pagination');
    const dt = await session.getLocalPersistence();
    if (dt?.[category]) {
      setState(dt?.[category]);
    } else {
      setState(10);
    }
  } catch (error) {
    throw new Error('Error fetching data');
  }
};

export { paginationSize, getPaginationSession };
